/**
 * Created by tbilou on 14.11.2014.
 */

import { GGSCountryController } from "./../../language/countryMapper/GGSCountryController";
import { ILODataFacade } from "./../../externalLogging/facade/ILODataFacade";

import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../basic/IEnvironmentGlobals";
import { BasicModel } from "../../basic/model/BasicModel";

import { Capabilities } from "@goodgamestudios/createjs-utilities";

export class LODataFacade implements ILODataFacade {

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public get httpReferer(): string {
        return this.env.referrer;
    }

    public get gameId(): string {
        return String(this.env.gameId);
    }

    public get sessionId(): string {
        return this.env.sessionId;
    }

    public get sessionLength(): string {
        return Math.floor(this.env.sessionLength).toString();
    }

    public get networkId(): string {
        return String(this.env.networkId);
    }

    public get instanceId(): string {
        if (BasicModel.instanceProxy.selectedInstanceVO) {
            return BasicModel.instanceProxy.selectedInstanceVO.instanceId + "";
        } else {
            return "Not available/defined yet";
        }
    }

    public get browserUserAgent(): string {
        return navigator.userAgent || "Not available";
    }

    public get browserPlatform(): string {
        return navigator.platform || "Not available";
    }

    public get browserVendor(): string {
        return navigator.vendor || "Not available";
    }

    public get os(): string {
        return Capabilities.os;
    }

    public get clientVersion(): string {
        return this.env.buildNumberGame;
    }

    public get itemXMLVersion(): string {
        return this.env.versionInformation.itemXmlVersion;
    }

    public get clientType(): string {
        let type: string = "all";

        if (this.env.isPreClient) {
            //set the client type preclient to be able to distinguish the environments, default is ALL
            type = "preClient";
        }

        return type;
    }

    public get cdn(): string {
        return this.env.cdnSubDomain;
    }

    public get countryCode(): string {
        if (GGSCountryController.instance.currentCountry) {
            return GGSCountryController.instance.currentCountry.ggsCountryCode;
        } else {
            return "Not available/defined yet";
        }
    }

    public get languageCode(): string {
        if (GGSCountryController.instance.currentCountry) {
            return GGSCountryController.instance.currentCountry.ggsLanguageCode;
        } else {
            return "Not available/defined yet";
        }
    }

    public get isFirstVisitOfGGS(): string {
        return this.env.isFirstVisitOfGGS.toString();
    }

    public get accountId(): string {
        return this.env.accountId;
    }

    public get playerId(): string {
        if (BasicModel.userData) {
            return String(BasicModel.userData.playerID);
        } else {
            return "Not available/defined yet";
        }
    }

    public get connectionType(): string {
        return "Not available";
    }

    public get deviceType(): string {
        return Capabilities.isMobile ? "Mobile" : "Desktop";
    }

    public get isFirstAppStartAfterUpdate(): string {
        return "Not available";
    }

    public get deviceCategory(): string {
        return "Not available";
    }

    public get isInBackground(): string {
        return "Not available";
    }

    public get sourceStore(): string {
        return "Not available";
    }

    public get performanceCategory(): string {
        return "Not available";
    }
}
